//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Button, Input, Row, Select, Space } from "antd";
import { useAppDispatch, useAppSelector } from "store";
import { setLoading } from "store/slices/loadingSlice";
import NotFoundData from "components/NotFoundData";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import {  GetTransportShipedResponseData,  } from "services/interface";
import { useGetBankActiveList, useGetBankAllList } from "hooks/useFactory";
import { CreditCardOutlined, TableOutlined } from "@ant-design/icons";
import OrderTableList from "./OrderTableList";
const { Option } = Select;

interface ShippingShippedProps {
  data: GetTransportShipedResponseData | undefined;
  isLoading: boolean;
  refetch: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string  // currentPage: number;
  // setCurrentPage: Dispatch<SetStateAction<number>>;
  // itemsPerPage: number;
  // setSearch: Dispatch<SetStateAction<string>>;
  refetchPrepare: () => void;
}

const ShippingShipped: FC<ShippingShippedProps> = ({
  data,
  isLoading,
  refetch,
  setSearchInput,
  searchInput,
  refetchPrepare,
}) => {



  const dispatch = useAppDispatch();
  const factory_id = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
  const [isTable, setIsTable] = useState<boolean>(true);

  const { data: dataBank } = useGetBankActiveList(factory_id || '');

  const childrenBank: React.ReactNode[] = [];
  dataBank?.data?.map((item) => {
    return childrenBank.push(
      <Option key={item.id} value={item.id}>
        {item.bank_name} {item.account_no} {item.account_name}
      </Option>
    );
  });

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  
  }, [dispatch, isLoading]);

  const handleButtonClick = () => {
    setIsTable((prevValue) => !prevValue); // สลับค่าระหว่าง true และ false เมื่อกดปุ่ม
  };

  if (!data || data.order_data.length === 0) {
    return <NotFoundData text="ยังไม่มีรายการคำสั่งซื้อ" />;
  }

  const refetchData = () => {
    refetch();
  };

  return (
    <>
     <WrapperAll>
      <HeadWrapper>

        <ButtonWrapper>
          {/* <Space.Compact>
            <Input 
              style={{height:'32px',width:'100px;'}} 
              placeholder="ค้นหาหมายเลขคำสั่งซื้อ"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <Button type="default" >ค้นหา</Button>
          </Space.Compact> */}
        </ButtonWrapper>
        {/* <PaginationWrapper
          current={currentPage}
          size={'small'}
          responsive={true}
          // totalBoundaryShowSizeChanger={3}
          onChange={(page) => setCurrentPage(page)}
          // total={data?.contacts?.length || 0}
          total={data?.data?.total_record}
          // defaultCurrent={3} 
          pageSize={itemsPerPage}
          // showSizeChanger={true}
        /> */}
        {/* <Button type="default" onClick={handleButtonClick}>
          {isTable ? "แสดงแบบ Cards" : "แสดงแบบ Table"}
        </Button> */}
        </HeadWrapper>
      <Row gutter={[16, 16]} style={{ overflow: "auto", backgroundColor: "#EFEFEF" }}>
        {
          isTable ?
          <CardWrapperTable>          
            <OrderTableList 
              data={data}
              childrenBank={childrenBank}
              refetchData={refetchData}
              refetchPrepare={refetchPrepare}
            />
          </CardWrapperTable>
          :
          <>
         
          </>
        }

        </Row>
      </WrapperAll>
    </>
  );
};

export default ShippingShipped;

// const PaginationWrapper = styled(Pagination)`
//   white-space: nowrap;
// `;
const WrapperAll = styled.div`
  padding: 10px 10px 10px 8px;
  background-color: #efefef;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;
const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
